export default function ProgressBar({percentage}) {
  return (
    <div className="h-2 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-full">
      <div className="absolute inset-0 border border-transparent rounded-full">
        <div className="absolute right-0 top-0 bg-white h-full rounded-full transition-all duration-1000 ease-linear" style={{width: `${percentage}%`}}></div>
      </div>
    </div>
  )
}
